import { Record, Set } from 'immutable'

const NoteHistoryRecord = Record({
  id: null,
  createdAt: null,
  from: null,
  to: null,
  op: [],
  noteId: null,
  userIds: Set(),
})

export default NoteHistoryRecord
